// React
import React, { useState } from 'react';

// Src
import { ReactComponent as ChevronFilledDownIcon } from '@/assets/icons/chevron-filled-down.svg';
import { ReactComponent as ChevronFilledRightIcon } from '@/assets/icons/chevron-filled-right.svg';

// Styles
import classes from './NavMenu.module.scss';

// Types
type Props = {
    children: React.ReactNode;
    defaultOpen?: boolean;
    title: string;
};

const NavMenu = ({ defaultOpen = false, children, title }: Props) => {
    // States
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div>
            <div
                className={classes.DisclosureButton}
                onClick={() => setOpen(!open)}
            >
                <div className={classes.IconWrapper}>
                    {open ? (
                        <ChevronFilledDownIcon />
                    ) : (
                        <ChevronFilledRightIcon />
                    )}
                </div>
                <div className={classes.DisclosureTitle}>{title}</div>
            </div>
            <nav>{open && children}</nav>
        </div>
    );
};

export default NavMenu;
